module.exports = __webpack_public_path__ + "media/images/dashboard/wedding_styles/rustic1-72d31b395109f796ac66c2060d644b3e.jpg";